var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Booking Requests Sent","type":"practice-requests-sent","items-shown":5,"items":_vm.offers,"event-name":"load-practice-requests"},on:{"load-practice-requests":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }